import {
  BillingLineGrain,
  GetV1CompaniesCompanyIdOrdersDispatchData,
  GetV1CompaniesCompanyIdOrdersOrderIdJobsInvoicingData,
} from '@treadinc/horizon-api-spec';

import {
  ChargesGrainTab,
  ChargesView,
  getAiReviewStatuses,
  getBillingStates,
  isShowingApprovedWork,
} from './approveChargesTabs';

type OrdersDispatchQuery = GetV1CompaniesCompanyIdOrdersDispatchData['query'];
type JobsInvoicingQuery = GetV1CompaniesCompanyIdOrdersOrderIdJobsInvoicingData['query'];

const grainByGrainTab = {
  [ChargesGrainTab.HOURLY_JOBS]: BillingLineGrain.JOB,
  [ChargesGrainTab.LOADS]: BillingLineGrain.LOAD,
} satisfies Record<ChargesGrainTab, BillingLineGrain>;

// The orders endpoint prefixes these params with the job; the jobs endpoint does not.
export function deriveApproveChargesQueries(
  view: ChargesView,
  grainTab: ChargesGrainTab,
) {
  const aiReviewStatuses = getAiReviewStatuses(view);
  const billingStates = getBillingStates(view);
  const grain = grainByGrainTab[grainTab];
  const isApprovedWork = isShowingApprovedWork(view);
  const isHourlyTab = grainTab === ChargesGrainTab.HOURLY_JOBS;

  const jobsQuery: JobsInvoicingQuery = {
    ...(aiReviewStatuses && { 'filter[ai_review][statuses]': aiReviewStatuses }),
    ...(isApprovedWork &&
      (isHourlyTab
        ? { 'filter[billing_approved]': true }
        : { 'filter[load][billing_approved]': true })),
    'filter[billing_status]': billingStates,
    'filter[grain]': grain,
  };
  const ordersQuery: OrdersDispatchQuery = {
    ...(aiReviewStatuses && { 'filter[job][ai_review][statuses]': aiReviewStatuses }),
    ...(isApprovedWork &&
      (isHourlyTab
        ? { 'filter[job][billing_approved]': true }
        : { 'filter[job][load][billing_approved]': true })),
    'filter[job][billing_status]': billingStates,
    'filter[job][grain]': grain,
  };

  return { jobsQuery, ordersQuery };
}
